(function () {
    'use strict';

    function main() {
        var page = wo$('#share-search-results');
        if (!page.length) return;
        var data = WhistleOut.readLookupData(page);

        var controller = {
            init: function () {
                page.find('#embed-code, #share-url')
                    .off('click')
                    .click(function () {
                        WhistleOut.focusAndSelect(this, true);
                        WhistleOut.triggerPopoverNotification(this, data.resources.copied, 'bottom');
                    });

                page.on('show.bs.modal', function () {
                    var url = WhistleOut.replaceQueryString(data.embedInfoUrl, location.search);
                    wo$.ajax({
                        type: 'GET',
                        url: url,
                        async: true
                    })
                        .done(function (updatedData) {
                            data = updatedData;
                            controller.updateShareUrl();
                            page.find('#show-heading').attr('checked', data.IsShowHeadingChecked);
                            var customHeadingDiv = wo$('#custom-headings');
                            if (data.IsShowHeadingChecked) {
                                customHeadingDiv.removeClass('hidden');
                            } else {
                                customHeadingDiv.addClass('hidden');
                            }
                        })
                        .always(function () {
                            controller.updatePreview(true);
                        });
                    if (page.find('input#showWidgetCode').length) {
                        page.find('input#showWidgetCode').prop('checked', false);
                        page.find('input#embed-code').addClass('hidden');
                    }
                });

                page.find('input#showWidgetCode').change(function () {
                    if (this.checked) {
                        page.find('input#embed-code').removeClass('hidden');
                        page.find('input#embed-code').click();
                    } else {
                        page.find('input#embed-code').addClass('hidden');
                    }
                });

                var customHeading = wo$('#custom-headings');
                page.find('input#show-heading').change(function () {
                    customHeading.toggleClass('hidden');
                });

                var headingTimeout;
                page.find('input#custom-heading-input').on('input', function () {
                    clearTimeout(headingTimeout);
                    headingTimeout = window.setTimeout(function () {
                        controller.updatePreview(true);
                    }, 1000);
                });

                var subheadingTimeout;
                page.find('input#custom-subheading-input').on('input', function () {
                    clearTimeout(subheadingTimeout);
                    subheadingTimeout = window.setTimeout(function () {
                        controller.updatePreview(true);
                    }, 1000);
                });

                var dataUpdateTimeout;
                page.find('[data-update]').on('change', function () {
                    clearTimeout(dataUpdateTimeout);
                    dataUpdateTimeout = window.setTimeout(function () {
                        controller.updatePreview(true);
                    }, 500);
                });

                page.find('#amp')
                    .off('click')
                    .on('click', function () {
                        controller.updatePreview(false);
                    });

                page.find('#short-url')
                    .off('click')
                    .click(function () {
                        controller.updateShareUrl();
                        WhistleOut.focusAndSelect(wo$('#share-url'));
                    });

                wo$(window).on('message', function (event) {
                    if (
                        event.originalEvent.data &&
                        Object.prototype.hasOwnProperty.call(event.originalEvent.data, 'sentinel') &&
                        event.originalEvent.data.sentinel === 'whistleout-widget'
                    ) {
                        page.find('#embed-preview').height(event.originalEvent.data.height);
                    }
                });
            },

            getEncodedValue: function (page, element) {
                var value = page.find(element).val();
                return value ? encodeURIComponent(WhistleOut.encodeHtml(value)) : null;
            },

            updatePreview: function (refreshWidget) {
                try {
                    var maxNumberOfResults = page.find('#max-results').val();
                    var includeFeaturedResults = page.find('#include-featured-results').is(':checked');
                    var singleResultPerSupplier = page.find('#single-result-supplier').is(':checked');
                    var onlyMonetisedProducts = page.find('#only-monitised-products').is(':checked');
                    var showHeading = page.find('#show-heading').is(':checked');
                    var showNumbers = page.find('#show-numbers');

                    var query = 'n=' + maxNumberOfResults;
                    if (includeFeaturedResults)
                        query = WhistleOut.appendQueryParam(query, 'f=' + includeFeaturedResults);
                    if (!singleResultPerSupplier)
                        query = WhistleOut.appendQueryParam(query, 's=' + singleResultPerSupplier);
                    if (onlyMonetisedProducts) query = WhistleOut.appendQueryParam(query, 'm=' + onlyMonetisedProducts);

                    var code;
                    var amp = page.find('#amp').is(':checked');
                    var embedAmpUrl = (data.embedAmpUrl + '?' + query).replace(/&/g, '&amp;');

                    var heading;
                    var subheading;
                    if (!showHeading) {
                        query = WhistleOut.appendQueryParam(query, 'h=' + showHeading);
                    } else {
                        heading = this.getEncodedValue(page, 'input#custom-heading-input');
                        if (heading) {
                            const p = 'hd=' + heading;
                            query = WhistleOut.appendQueryParam(query, p);
                            embedAmpUrl = WhistleOut.appendQueryParam(embedAmpUrl, p);
                        }

                        subheading = this.getEncodedValue(page, 'input#custom-subheading-input');
                        if (subheading) {
                            const p = 'shd=' + subheading;
                            query = WhistleOut.appendQueryParam(query, p);
                            embedAmpUrl = WhistleOut.appendQueryParam(embedAmpUrl, p);
                        }
                    }

                    if (showNumbers.length === 1 && !showNumbers.is(':checked')) {
                        query = WhistleOut.appendQueryParam(query, 'sn=false');
                    }

                    if (amp) {
                        code = data.embedAmpFormatString.replace('{ampurl}', embedAmpUrl);
                    } else {
                        var embedUrl = data.embedUrl + '?' + query;
                        if (data.encode) {
                            embedUrl = embedUrl.replace(/&/g, '&amp;');
                        }

                        var embedIFrameUrl = (data.embedIFrameUrl + '?' + query).replace(/&/g, '&amp;');
                        code = data.embedFormatString
                            .replace('{url}', embedUrl)
                            .replace('{ampurl}', embedAmpUrl)
                            .replace('{iframeurl}', embedIFrameUrl);
                    }

                    page.find('#embed-code').val(code).css('background-color', 'rgba(255,255,0,.3)').animate(
                        {
                            backgroundColor: 'white'
                        },
                        2000
                    );

                    if (refreshWidget) {
                        var previewUrl = WhistleOut.updateQueryStringParameter(
                            data.previewUrl,
                            'maxresults',
                            maxNumberOfResults
                        );
                        previewUrl = WhistleOut.updateQueryStringParameter(
                            previewUrl,
                            'includefeatured',
                            includeFeaturedResults
                        );
                        if (singleResultPerSupplier) {
                            previewUrl = WhistleOut.updateQueryStringParameter(
                                previewUrl,
                                'maxresultspersupplier',
                                '1'
                            );
                        }
                        if (onlyMonetisedProducts) {
                            previewUrl = WhistleOut.updateQueryStringParameter(
                                previewUrl,
                                'monetised',
                                onlyMonetisedProducts
                            );
                        }
                        previewUrl = WhistleOut.updateQueryStringParameter(
                            previewUrl,
                            'showwidgetheading',
                            showHeading
                        );

                        if (heading) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'hd', heading);
                        }

                        if (subheading) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'shd', subheading);
                        }

                        if (showNumbers.length === 1 && !showNumbers.is(':checked')) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'shownumbers', false);
                        }

                        page.find('#embed-preview').attr('src', previewUrl);
                    }
                    // eslint-disable-next-line no-empty
                } catch (e) {}
            },

            updateShareUrl: function () {
                var url = page.find('#short-url').is(':checked') ? data.shareShortUrl : data.shareUrl;
                page.find('#share-url').val(url);
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
